import * as $protobuf from "protobufjs";

const $root = (
  $protobuf.roots.default || ($protobuf.roots.default = new $protobuf.Root())
)
  .setOptions({
    syntax: "proto3",
  })
  .addJSON({
    Agora: {
      nested: {
        SpeechToText: {
          nested: {
            Text: {
              fields: {
                culture: { id: 15, type: "string" },
                dataType: { id: 13, type: "string" },
                durationMs: { id: 12, type: "int32" },
                endOfSegment: { id: 11, type: "bool" },
                flag: { id: 5, type: "int32" },
                lang: { id: 7, type: "int32" },
                offtime: { id: 9, type: "int32" },
                sentenceEndIndex: { id: 17, type: "int32" },
                seqnum: { id: 3, type: "int32" },
                starttime: { id: 8, type: "int32" },
                textTs: { id: 16, type: "int64" },
                time: { id: 6, type: "int64" },
                trans: { id: 14, rule: "repeated", type: "Translation" },
                uid: { id: 4, type: "int64" },
                vendor: { id: 1, type: "int32" },
                version: { id: 2, type: "int32" },
                words: { id: 10, rule: "repeated", type: "Word" },
              },
            },
            Translation: {
              fields: {
                isFinal: { id: 1, type: "bool" },
                lang: { id: 2, type: "string" },
                texts: { id: 3, rule: "repeated", type: "string" },
              },
            },
            Word: {
              fields: {
                confidence: { id: 5, type: "double" },
                durationMs: { id: 3, type: "int32" },
                isFinal: { id: 4, type: "bool" },
                startMs: { id: 2, type: "int32" },
                text: { id: 1, type: "string" },
              },
            },
          },
          options: {
            csharp_namespace: "AgoraSTTSample.Protobuf",
            java_outer_classname: "AgoraSpeech2TextProtobuffer",
            java_package: "io.agora.rtc.speech2text",
            objc_class_prefix: "Stt",
          },
        },
      },
    },
  });

export { $root as default };
